import { render, staticRenderFns } from "./AgendaAulaTeorico.vue?vue&type=template&id=47876884"
import script from "./AgendaAulaTeorico.vue?vue&type=script&lang=js"
export * from "./AgendaAulaTeorico.vue?vue&type=script&lang=js"
import style0 from "./AgendaAulaTeorico.vue?vue&type=style&index=0&id=47876884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports